
/**
 *  @param SavedCreditCard deprecated
 *  @param NewCreditCard processed by Relax and saves full card details on Roomex's database
 *  @param PaymentElement processed by Stripe and saves a reference of the card
 *  @param SavedPaymentElement saved credit cards 
 */
export enum PaymentMethodOptions {
  OnAccount = 'onaccount',
  SavedCreditCard = 'card',
  NewCreditCard = 'new',
  PaymentElement = 'paymentElement',
  SavedPaymentElement = 'savedPaymentElement'
}

export interface PaymentMethodsAvailable {
  onAccount: boolean;
  newCreditCardRelax: boolean;
  newCreditCardStripe: boolean;
  savedCreditCard: boolean;
}

export enum CreditCardPaymentTime {
  None = '',
  PaidByBrand = 'paidByBrand',
  PayInAdvance = 'paymentTakenByHotelInAdvance',
  PayAtHotel = 'paymentByHotelAtCheckout'
}